import React from 'react';
import PropTypes from 'prop-types';
import { useFormState } from 'react-final-form';
import DonationDirectDebit from '../../../../../02_molecules/DirectDebitForm';
import Button from '../../../../../01_atoms/Button';
import TotalCost from '../../../../../02_molecules/TotalCost';

import styles from './index.module.scss';

const BankAccountForm = ({ onSubmitForm, buttonType = 'primary' }) => {
  const { values } = useFormState();
  return (
    <div className={styles['bank-account-form']}>
      <div className={styles['bank-account-form__container']}>
        <div className={styles['bank-account-form__container-left']}>
          <div className={styles['bank-account-form__title']}>Bank account</div>
          <div className={styles['bank-account-form__description']}>
            Enter your bank details below
          </div>
          <DonationDirectDebit />
          <TotalCost values={values} />
          <Button
            data-component="inline-donation-form-bank-account-submit"
            type={buttonType}
            isBlock
            className={styles['bank-account-form__submit-button']}
            onClick={onSubmitForm}
          >
            Pay with Bank Account
          </Button>
        </div>
      </div>
    </div>
  );
};

BankAccountForm.propTypes = {
  buttonType: PropTypes.oneOf(['primary', 'emergency']),
  onSubmitForm: PropTypes.func.isRequired,
};

export default BankAccountForm;
